export default __webpack_public_path__ + "static/justin2-4e7f0e5d41e0aab17aec1e8e45c81443.png";